import { getApiUrl } from './apiConfig';

type ConnectionListener = (isDisconnected: boolean) => void;

let isDisconnected = false;
const listeners: ConnectionListener[] = [];

export const setConnectionError = (error: boolean) => {
    const wasDisconnected = isDisconnected;
    if (isDisconnected !== error) {
        isDisconnected = error;
        listeners.forEach(listener => listener(isDisconnected));
        
        if (wasDisconnected && !error) {
            window.location.reload();
        }
    }
};

export const getConnectionError = () => isDisconnected;

export const addConnectionListener = (listener: ConnectionListener) => {
    listeners.push(listener);
    return () => {
        const index = listeners.indexOf(listener);
        if (index > -1) listeners.splice(index, 1);
    };
};

export const checkConnection = async (): Promise<boolean> => {
    try {
        const response = await fetch(getApiUrl(), {
            method: 'HEAD',
            mode: 'cors',
            cache: 'no-cache'
        });
        if (response.ok) {
            setConnectionError(false);
            return true;
        }
        setConnectionError(true);
        return false;
    } catch {
        setConnectionError(true);
        return false;
    }
};
